import { cn } from "@/lib/utils";

export interface InvoicePdfFrameProps {
  invoiceId: number;
  className?: string;
  title?: string;
}

export function InvoicePdfFrame({ invoiceId, className, title }: InvoicePdfFrameProps) {
  const src = `/api/invoices/${invoiceId}/pdf`;
  return (
    <div className={cn("flex flex-col gap-2", className)}>
      <iframe
        title={title ?? "Invoice PDF"}
        src={src}
        className="w-full h-[800px] border rounded-md bg-white"
      />
      <a
        href={src}
        download
        className="text-sm text-primary underline self-start"
      >
        Download
      </a>
    </div>
  );
}
